'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Column(name, displayAs, render, onMount, sorting, autoWidth) {
  this.os = null;
  this.tN = null;
  this.CD = null;
  this.JQ = null;
  this.wT = null;
  this.CC = false;
  this.os = name;
  this.tN = displayAs;
  this.CD = render;
  this.JQ = onMount;
  this.wT = sorting;
  this.CC = autoWidth;
}
export { $c_Lpresto_Column as $c_Lpresto_Column };
$p = $c_Lpresto_Column.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Column;
/** @constructor */
function $h_Lpresto_Column() {
}
export { $h_Lpresto_Column as $h_Lpresto_Column };
$h_Lpresto_Column.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Column"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.os));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tN));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.CD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.JQ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wT));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.CC ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Column)) {
    if ((((this.CC === x$0.CC) && (this.os === x$0.os)) && (this.tN === x$0.tN))) {
      var x = this.CD;
      var x$2 = x$0.CD;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.JQ;
      var x$4 = x$0.JQ;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.wT;
      var x$6 = x$0.wT;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "Column";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.os;
      break;
    }
    case 1: {
      return this.tN;
      break;
    }
    case 2: {
      return this.CD;
      break;
    }
    case 3: {
      return this.JQ;
      break;
    }
    case 4: {
      return this.wT;
      break;
    }
    case 5: {
      return this.CC;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_Column(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hV)));
}
export { $isArrayOf_Lpresto_Column as $isArrayOf_Lpresto_Column };
var $d_Lpresto_Column = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Column, "presto.Column", ({
  hV: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Column as $d_Lpresto_Column };
//# sourceMappingURL=presto.-Column.js.map
